import { MetricItem } from "../Common/types";
import { status } from "../Common/types";

const metrics: MetricItem[] = [
  {
    id: "exercise",
    title: "Exercise",
    value: "300 minutes",
    status: status.healthy,
    showChevron: true,
  },
  {
    id: "sleep",
    title: "Sleep",
    value: "Ave. 7 hours",
    status: status.healthy,
    showChevron: true,
  },
  {
    id: "diet",
    title: "Diet",
    value: "Good",
    status: status.healthy,
    showChevron: false,
  },
  {
    id: "alcohol",
    title: "Alcohol",
    value: "10 per day",
    status: status.needsSupport,
    showChevron: false,
  },
  {
    id: "smoking",
    title: "Smoking",
    value: "Never",
    status: status.healthy,
    showChevron: false,
  },
];

export { metrics };
